module.exports = __webpack_public_path__ + "static/img/miro-visual-search-as-a-service.8b50355.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/miro-visual-search-as-a-service.png
// module id = uNZE
// module chunks = 1